import { Navigate, useParams } from "react-router-dom";

/**
 * Contractor has no unified ProjectWorkspace yet — legacy/wrong menu links land here.
 */
const ContractorProjectWorkspaceRedirect = () => {
  const { id } = useParams();
  if (id) {
    return <Navigate to={`/SLN/Contractor/InProcessRequest/${id}`} replace />;
  }
  return <Navigate to="/SLN/Contractor/InProcessRequest" replace />;
};

export default ContractorProjectWorkspaceRedirect;
